export const Member = {
  AUTHENTICATING: "AUTHENTICATING",
  UNAUTHENTICATING: "UNAUTHENTICATING",
  AUTHENTICATION_FAILURE: "AUTHENTICATION_FAILURE",
  AUTHENTICATION_INVALID_CREDENTIALS: "AUTHENTICATION_INVALID_CREDENTIALS",
  AUTHENTICATION_FAILURE_USER_NOT_FOUND: "AUTHENTICATION_FAILURE_USER_NOT_FOUND",
  AUTHENTICATION_FAILURE_MEMBERSHIP_NOT_ACTIVE: "AUTHENTICATION_FAILURE_MEMBERSHIP_NOT_ACTIVE",
  AUTHENTICATION_FAILURE_MEMBERSHIP_CLOSED: "AUTHENTICATION_FAILURE_MEMBERSHIP_CLOSED",
  AUTHENTICATION_FAILURE_MEMBERSHIP_SUSPENDED: "AUTHENTICATION_FAILURE_MEMBERSHIP_SUSPENDED",
  AUTHENTICATION_FAILURE_EXTERNAL_SYSTEM_ERROR: "AUTHENTICATION_FAILURE_EXTERNAL_SYSTEM_ERROR",
  EMAIL_IS_AVAILABLE: "EMAIL_IS_AVAILABLE",
  FAIL_ON_PROGRAM_LOOKUP: "FAIL_ON_PROGRAM_LOOKUP",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
  REGISTRATION_CODE_VERIFIED: "REGISTRATION_CODE_VERIFIED",
  MEMBER_ID_VERIFIED: "MEMBER_ID_VERIFIED",
  REGISTERING: "REGISTERING",
  SUCCESSFUL: "SUCCESSFUL",
  FAILURE: "FAILURE",
  AUTHENTICATION_SUCCESSFUL: "AUTHENTICATION_SUCCESSFUL",
  UNAUTHENTICATING_SUCCESSFUL: "UNAUTHENTICATING_SUCCESSFUL",
  UNAUTHENTICATING_FAILURE: "UNAUTHENTICATING_FAILURE",
  REGISTRATION_FAILURE: "REGISTRATION_FAILURE",
  REGISTRATION_SUCCESSFUL: "REGISTRATION_SUCCESSFUL",
  SIGN_IN_SUCCESSFUL: "SIGN_IN_SUCCESSFUL",
  VALIDATING_SESSION: "VALIDATING_SESSION",
  INVALID_MEMBER_KEY: "INVALID_MEMBER_KEY",
  MEMBER_ALREADY_REGISTERED: "MEMBER_ALREADY_REGISTERED",
  EMAIL_ALREADY_REGISTERED: "EMAIL_ALREADY_REGISTERED",
  MISSING_REQUEST_BODY_FIELD: "MISSING_REQUEST_BODY_FIELD",
  INVALID_PROGRAM_KEY: "INVALID_PROGRAM_KEY",
  EMPTY_PASSWORD: "EMPTY_PASSWORD",
  FAIL_ON_UNKNOWN_PROPERTIES: "FAIL_ON_UNKNOWN_PROPERTIES",
  SHARED_SECRET_INVALID: "SHARED_SECRET_INVALID",
  INVALID_CAPTCHA: "INVALID_CAPTCHA",
  LOADING: "LOADING",
  SAVING: "SAVING",
  LOAD_SUCCESS: "LOAD_SUCCESS",
  SAVE_SUCCESS: "SAVE_SUCCESS",
  LOAD_FAILURE: "LOAD_FAILURE",
  SAVE_FAILURE: "SAVE_FAILURE",
  REGISTER_WITH_MEMBER_KEY: "REGISTER_WITH_MEMBER_KEY",
  REGISTER_WITH_EMAIL: "REGISTER_WITH_EMAIL",
  REGISTER_WITH_CODE: "REGISTER_WITH_CODE",
  DEALS_SSO: "DEALS_SSO",
  COMPLETING_SETUP: "COMPLETING_SETUP",
  COMPLETING_SETUP_SUCCESSFUL: "COMPLETING_SETUP_SUCCESSFUL",
  COMPLETING_SETUP_FAILURE: "COMPLETING_SETUP_FAILURE",
  CVT_STATUS: {
    AUTHENTICATED: "AUTHENTICATED",
    NEEDS_PASSWORD: "NEEDS_PASSWORD",
    NOT_REGISTERED: "NOT_REGISTERED",
  },
  CVT_SESSION: "adc_d_cvtSession",
  NEEDS_SHARED_SECRET: "NEEDS_SHARED_SECRET",
};
